import {

    RESET_REVIEWING_REPORT,

    VIEW_WORKLIST_VISIT_SUCCESS,
    VIEW_WORKLIST_VISIT_ERROR,
    VIEW_WORKLIST_VISIT_START,

    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR,

    VIEW_PARKED_VISIT_START,
    VIEW_PARKED_VISIT_SUCCESS,
    VIEW_PARKED_VISIT_ERROR,

    VIEW_VERIFIED_VISIT_START,
    VIEW_VERIFIED_VISIT_SUCCESS,
    VIEW_VERIFIED_VISIT_ERROR,

    VIEW_SUBMITTED_TO_TYPIST_VISIT_START,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR,

    UPDATE_VISIT_REPORT_STATE_START,
    UPDATE_VISIT_REPORT_STATE_SUCCESS,
    UPDATE_VISIT_REPORT_STATE_ERROR,

    FETCH_PATIENT_HISTORY_REPORTS_START,
    FETCH_PATIENT_HISTORY_REPORTS_ERROR,
    FETCH_PATIENT_HISTORY_REPORTS_SUCCESS,

    UNLOCK_VISIT_START,
    UNLOCK_VISIT_SUCCESS,
    UNLOCK_VISIT_ERROR,
    UPDATE_TICKET_ID,

    SAVE_VISIT_REPORT_DICTATION_SUCCESS,
    SUBMIT_VISIT_REPORT_DICTATION_START,
    SUBMIT_VISIT_REPORT_DICTATION_SUCCESS,
    SUBMIT_VISIT_REPORT_DICTATION_ERROR,

    UNASSIGN_MIS1_SUCCESS,
    ASSIGN_MIS2_TO_VISIT_SUCCESS,
    SAVE_DICTATION_AUDIO_SUCCESS,
    SAVE_DICTATION_AUDIO_ERROR,
    SET_DICTATION_AUDIO_UPLOAD_PROGRESS,
    UPDATE_STUDY_SUCCESS,
    ADD_REPORT_DIAGRAM_SUCCESS
} from '../../actions/mis/reportViewerAction';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    searchParams: null,
    found: false,
    report: null,
    unlocking: false,
    priorReportsLoaded: false,
    patientHistoryReports: [],
    audioUpload: {
        uploading: false,
        percentCompleted: 0,
        error: false,
    }
};

const createPendingReport = (report) => {
    if (!report) {
        return null;
    }

    return {
        reportId: report.reportId,
        patient: {
            pid: report.pid,
            firstName: report.firstName,
            lastName: report.lastName,
            dob: report.dob,
            sex: report.sex
        },
        visit: {
            ...report
        },
        primeStudyInfo: null,
        dictations: [],
        attachments: [],
        diagrams: []
    };
};

const reportViewerReducer = (state = INIT_STATE, action) => {
    let newState;
    let newReport;
    let index;
    switch (action.type) {
        case VIEW_WORKLIST_VISIT_START:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START:
        case VIEW_PARKED_VISIT_START:
        case VIEW_VERIFIED_VISIT_START:
        case VIEW_SUBMITTED_TO_TYPIST_VISIT_START: {
            return { ...state, error: '', message: '', found: false, loading: true, report: action.report ? createPendingReport(action.report) : state.report };
        }
        case VIEW_WORKLIST_VISIT_SUCCESS:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS:
        case VIEW_PARKED_VISIT_SUCCESS:
        case VIEW_VERIFIED_VISIT_SUCCESS:
        case VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS: {
            return { ...state, error: '', message: '', found: true, loading: false, report: { ...action.report } };
        }
        case VIEW_WORKLIST_VISIT_ERROR:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR:
        case VIEW_PARKED_VISIT_ERROR:
        case VIEW_VERIFIED_VISIT_ERROR:
        case VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR: {
            return { ...state, error: '', message: '', found: false, loading: false };
        }
        case FETCH_PATIENT_HISTORY_REPORTS_SUCCESS: {
            return { ...state, error: '', message: '', patientHistoryReports: action.patientHistoryReports, priorReportsLoaded: true };
        }
        case UPDATE_VISIT_REPORT_STATE_START: {
            return { ...state, error: '', message: '', submitting: true };
        }
        case UPDATE_VISIT_REPORT_STATE_SUCCESS: {
            newReport = { ...state.report };
            newReport.visit = { ...action.visit };
            return {
                ...state,
                error: '',
                message: '',
                submitting: false,
                report: {
                    ...newReport
                }
            };
        }
        case UPDATE_VISIT_REPORT_STATE_ERROR: {
            return { ...state, error: '', message: '', submitting: false };
        }
        case RESET_REVIEWING_REPORT: {
            return { ...INIT_STATE };
        }
        case UNLOCK_VISIT_START: {
            return { ...state, unlocking: true };
        }
        case UNLOCK_VISIT_SUCCESS: {
            return { ...state, unlocking: false };
        }
        case UNLOCK_VISIT_ERROR: {
            return { ...state, unlocking: false, error: action.error || '' };
        }
        case UPDATE_TICKET_ID: {
            newState = { ...state };
            if (action.ticket.reportId === newState.report.visit.reportId) {
                let report = { ...newState.report };
                report.visit = { ...report.visit, ticketId: action.ticket.ticketId };
                return { ...state, report };
            }
            return newState;
        }

        case SUBMIT_VISIT_REPORT_DICTATION_START: {
            return { ...state, error: '', message: '', submitting: true };
        }
        case SUBMIT_VISIT_REPORT_DICTATION_SUCCESS: {
            newState = { ...state, submitting: false, report: { ...action.report } };
            return newState;
        }
        case UNASSIGN_MIS1_SUCCESS: {
            newReport = { ...state.report };
            newReport.visit = { ...action.visit };
            return {
                ...state,
                error: '',
                message: '',
                submitting: false,
                report: {
                    ...newReport
                }
            };
        }
        case ASSIGN_MIS2_TO_VISIT_SUCCESS: {
            newReport = { ...state.report };
            newReport.visit = { ...action.visit };
            return {
                ...state,
                error: '',
                message: '',
                submitting: false,
                report: {
                    ...newReport
                }
            };
        }

        case SUBMIT_VISIT_REPORT_DICTATION_ERROR: {
            return { ...state, error: '', message: '', submitting: false };
        }
        case SET_DICTATION_AUDIO_UPLOAD_PROGRESS: {
            return {
                ...state,
                audioUpload: {
                    ...state.audioUpload,
                    uploading: action.payload.uploading,
                    percentCompleted: action.payload.percentCompleted,
                    error: false,
                }
            };
        }
        case SAVE_DICTATION_AUDIO_SUCCESS: {
            return {
                ...state,
                audioUpload: {
                    ...state.audioUpload,
                    uploading: false,
                    percentCompleted: 0,
                    error: false,
                }
            };
        }
        case SAVE_DICTATION_AUDIO_ERROR: {
            return {
                ...state,
                audioUpload: {
                    ...state.audioUpload,
                    error: true,
                }
            };
        }

        case UPDATE_STUDY_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.report.visit = { ...state.report.visit, priority: action.visit.priority }
            return { ...newState }
        }
        case ADD_REPORT_DIAGRAM_SUCCESS: {
            let modifiedDiagrams = [...state.report.diagrams];
            modifiedDiagrams.push(action.diagram);
            return {
                ...state,
                report: {
                    ...state.report,
                    diagrams: [...modifiedDiagrams]
                }
            };
        }
        default:
            return state;
    }
}

export default reportViewerReducer;
